import React from 'react';

export type InfoIconProps = {
    className?: string
}

export default function InfoIcon({className}: InfoIconProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
            <path d="M12 10.75V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 7.75H12.01" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
    )
}
